import {
  PersistedFormGroup,
  PersistedFormArray,
  PersistedArray,
} from './persisted-form-group';
import type {
  PersistedFormGroupOptions,
  PersistedFormArrayOptions,
  PersistedArrayOptions,
} from './persisted-form-group';
import type { SchemaFormControl } from '@apexdesigner/schema-forms';
import { Tutor } from './tutor';
export { Tutor };
import { tutorSchema } from '@schemas/business-objects/tutor';
import { TermTutorFormArray } from './term-tutor-form-group';
import { UserFormGroup } from './user-form-group';
import type { Role } from './role';
import type { RoleAssignment } from './role-assignment';

export class TutorFormGroup extends PersistedFormGroup {
  declare controls: {
    id: SchemaFormControl;
    title: SchemaFormControl;
    firstName: SchemaFormControl;
    lastName: SchemaFormControl;
    email: SchemaFormControl;
    inactive: SchemaFormControl;
    appUserId: SchemaFormControl;
    appUser: UserFormGroup;
    termTutors: TermTutorFormArray;
  };

  declare value: Partial<Tutor>;

  constructor(
    data?: Record<string, any> | null,
    options?: PersistedFormGroupOptions,
  ) {
    super(tutorSchema, Tutor, data, options);
  }

  get object(): Tutor {
    return new Tutor(this.getRawValue());
  }

  protected override createControl(name: string) {
    switch (name) {
      case 'appUser':
        return new UserFormGroup();
      case 'termTutors':
        return new TermTutorFormArray();
      default:
        return undefined;
    }
  }

  static async find(filter?: any): Promise<Tutor[]> {
    return Tutor.find(filter);
  }

  static async findOne(filter?: any): Promise<Tutor | null> {
    return Tutor.findOne(filter);
  }

  static async findById(id: number, filter?: any): Promise<Tutor> {
    return Tutor.findById(id, filter);
  }

  static async create(data: Partial<Tutor>): Promise<Tutor> {
    return Tutor.create(data as any);
  }

  static async updateById(id: number, updates: Partial<Tutor>): Promise<Tutor> {
    return Tutor.updateById(id, updates as any);
  }

  static async deleteById(id: number): Promise<boolean> {
    return Tutor.deleteById(id);
  }

  async createAppUser(): Promise<any> {
    const instance = new Tutor(this.getRawValue());
    return instance.createAppUser();
  }
}

export class TutorFormArray extends PersistedFormArray {
  readonly entityName = 'Tutor' as const;

  constructor(options?: PersistedFormArrayOptions) {
    super(tutorSchema, Tutor, options);
  }

  protected override createItemGroup() {
    return new TutorFormGroup();
  }

  get array(): Tutor[] {
    return this.controls.map((group: TutorFormGroup) => group.object);
  }
}

export class TutorPersistedArray extends PersistedArray<Tutor> {
  readonly entityName = 'Tutor' as const;

  constructor(options?: PersistedArrayOptions) {
    super(Tutor, options);
  }
}
